import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  InputGroup,
  Input,
  UncontrolledTooltip,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import _ from "lodash";
import API from "services/WebAPI";

const PopConfirm = ({ onOk }) => {
  const [modal, SetModal] = useState(false);

  const handleConfirm = () => {
    if (onOk) onOk();
    SetModal(false);
  };

  return (
    <>
      <Button
        color="danger"
        outline
        style={{ marginLeft: 5 }}
        onClick={() => SetModal(!modal)}
        size="sm"
      >
        Delete
      </Button>
      <Modal isOpen={modal} toggle={() => SetModal(false)}>
        <ModalHeader
          className="confirm-modal-header"
          style={{ paddingBottom: 0 }}
        >
          Are you sure to delete this webhook?
        </ModalHeader>
        <ModalFooter className="confirm-modal-footer" style={{ paddingTop: 0 }}>
          <Button color="danger" size="sm" onClick={handleConfirm}>
            <i className="far fa-trash-alt" style={{ marginRight: 5 }} />
            Continue
          </Button>{" "}
          <Button size="sm" outline onClick={() => SetModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

function EditHook({ data, open, onClose, update }) {
  const [_targets, setAvailable] = useState([]);

  const [target, setTarget] = useState("");
  const [url, setUrl] = useState("");
  const [type, setType] = useState(null);
  const [header, setHeader] = useState({});
  const [key, setKey] = useState("");
  const [value, setValue] = useState("");
  const [headerOpen, setHeaderOpen] = useState(false);
  const [requestType, setRequestType] = useState("");
  const [saving, setSaving] = useState(false);

  const { role } = useSelector((store) => store.authentication.user);

  useEffect(() => {
    if (role === "admin") {
      loadPartners();
    } else {
      loadCustomers();
    }
  }, []);

  useEffect(() => {
    if (data) {
      setTarget(role === "admin" ? data.PartnerId : data.CustomerId);
      setUrl(data.Url);
      setType(data.Type);
      setRequestType(data?.RequestType || "")
      if (data.Headers) {
        let head = {};
        try {
          head = JSON.parse(JSON.parse(data.Headers));
        } catch { }
        setHeader(head);
      }
    }
  }, [open]);

  const loadPartners = async () => {
    try {
      const response = await API.get("Partner/List");
      const { data: d, status } = response.data;
      if (status)
        setAvailable(
          d.map((e) => ({ id: e.PartnerId, emtity_name: e.EntityName }))
        );
    } catch { }
  };

  const loadCustomers = async () => {
    API.get(`/Customers/List?active=true`).then(({ data: res }) => {
      if (res.status)
        setAvailable(
          res.data.map((e) => ({ id: e.Id, emtity_name: e.CompanyName }))
        );
    });
  };

  const handleAddHeader = () => {
    if (!key || !value) return;
    const x = _.cloneDeep(header);
    _.set(x, key, value);
    setHeader(x);
    setKey("");
    setValue("");
  };

  const handleRemoveHeader = (key) => {
    const x = _.cloneDeep(header);
    delete x[key];
    setHeader(x);
  };

  const handleSave = async () => {
    if (!url || !target || type === undefined || type === null || !requestType) return;
    try {
      setSaving(true)
      const res = await API.post("Event/AddorUpdateNewPortalEvent/", {
        Id: data ? data.Id : undefined,
        [role === "admin" ? "partnerId" : "customerId"]: target === 'All' ? 0 : target,
        url,
        type,
        headers: JSON.stringify(header),
        requestType
      });
      if (res.data.status) {
        update();
        onCancel();
      }
    } catch (error) {
      console.log("error", error);
    }
    setSaving(false);
  };

  const handleDelete = async (id = data.Id) => {
    try {
      const res = await API.post(`Event/DeletePortalEvent?eventId=${id}`);
    } catch (error) {
      console.log("error", error);
    }
    update();
  };

  const displayTarget = (isTypeDropdwn) => {
    if (isTypeDropdwn) {
      if (type == null) {
        return "Action Type";
      }
      return type ? "Attack" : "License";
    }
    if (!target) {
      return role === "admin" ? "Partner" : "Customer";
    }
    return _targets.filter((t) => t.id === target)[0]?.emtity_name || target;
  };

  const displayRequestType = () => {
    let data = "Request Type";
    if (requestType === "http") data = "http://";
    if (requestType === "https") data = "https://";
    return data;
  };

  // closing edit tab
  const onCancel = () => {
    setTarget("");
    setUrl("");
    setType(null);
    setHeader({});
    setKey("");
    setValue("");
    setRequestType("")
    setHeaderOpen(false);
    if (onClose) onClose();
  };

  return (
    <div>
      <InputGroup style={{ marginTop: 3, marginBottom: 10 }}>
        <UncontrolledDropdown
          disabled={data}
          style={{
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            width: "auto",
            marginRight: 10,
          }}
        >
          <DropdownToggle style={{ fontWeight: 300 }} caret>
            {displayTarget()}
          </DropdownToggle>
          <DropdownMenu style={{ overflow: "auto", maxHeight: "60vh" }}>
            <DropdownItem onClick={() => setTarget("All")}>All</DropdownItem>xz
            {_targets.map(({ id, emtity_name }) => (
              <DropdownItem onClick={() => setTarget(id)}>
                {emtity_name}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </UncontrolledDropdown>
        <UncontrolledDropdown
          style={{
            width: "auto",
          }}
        >
          <DropdownToggle
            style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
            caret
          >
            {displayRequestType()}
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => setRequestType("http")}>
              http://
            </DropdownItem>
            <DropdownItem onClick={() => setRequestType("https")}>
              https://
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
        <Input
          placeholder="example.com"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          style={{ borderRadius: 0, paddingLeft: 10 }}
        />
        <Button
          id={`hader-option-tooltip-${data?.Id || "new"}`}
          outline
          style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
          onClick={() => setHeaderOpen((headerOpen) => !headerOpen)}
        >
          {headerOpen ? <i class="fas fa-times" /> : <i class="fas fa-cog" />}
        </Button>
        <UncontrolledTooltip
          target={`hader-option-tooltip-${data?.Id || "new"}`}
        >
          {headerOpen ? "hide header panel" : "configure request headers"}
        </UncontrolledTooltip>
        <UncontrolledDropdown
          disabled={data}
          style={{
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            width: "auto",
            marginLeft: 10,
          }}
        >
          <DropdownToggle style={{ fontWeight: 300 }} caret>
            {displayTarget(true)}
          </DropdownToggle>
          <DropdownMenu style={{ overflow: "auto", maxHeight: "60vh" }}>
            <DropdownItem onClick={() => setType(0)}>License</DropdownItem>
            <DropdownItem onClick={() => setType(1)}>Attack</DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
        {!data && (
          <Button
            color="primary"
            style={{ marginLeft: 20 }}
            onClick={handleSave}
          >
            {saving && (
              <span
                style={{ marginRight: 10 }}
                className="spinner-border spinner-border-sm"
              />
            )}
            Add
          </Button>
        )}
      </InputGroup>
      <Collapse isOpen={headerOpen} style={{ marginBottom: 5 }}>
        Request headers
        <div style={{ marginTop: 3, display: "flex", flexWrap: "wrap" }}>
          {Object.entries(header).map(([k, v]) => (
            <InputGroup style={{ width: 327, margin: 5 }}>
              <Input placeholder="key" value={k} disabled />
              <Input placeholder="value" value={v} disabled />
              <Button
                outline
                color="danger"
                onClick={() => handleRemoveHeader(k)}
                style={{
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                }}
              >
                <i class="fas fa-trash-alt" />
              </Button>
            </InputGroup>
          ))}

          <div style={{ width: 327, margin: 5 }}>
            <InputGroup>
              <Input
                placeholder="key"
                value={key}
                onChange={(e) => setKey(e.target.value)}
              />
              <Input
                placeholder="value"
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
              <Button
                outline
                onClick={handleAddHeader}
                style={{
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                }}
              >
                <i class="fas fa-plus" />
              </Button>
            </InputGroup>
          </div>
        </div>
      </Collapse>
      {data && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 25,
          }}
        >
          <PopConfirm onOk={handleDelete} />
          <div style={{ display: "flex" }}>
            <Button
              color="secondary"
              outline
              style={{ marginLeft: 5 }}
              onClick={onCancel}
              size="sm"
            >
              Cancel
            </Button>
            <Button
              color="primary"
              style={{ marginLeft: 5 }}
              onClick={handleSave}
              size="sm"
            >
              {saving && (
                <span
                  style={{ marginRight: 10 }}
                  className="spinner-border spinner-border-sm"
                />
              )}
              Update
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

export default EditHook;
